<template>
	<div>
		<div class="table-responsive">
			<table class="table table-striped table-bordered">
				<thead class="table-light">
					<tr>
						<th>Role</th>
						<th>Groups</th>
						<th>Owner</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="group in groups" :key="group.id">
						<td>
							{{
								group.pivot.role === 'group_owner'
									? 'Owner'
									: group.pivot.role === 'group_member'
									? 'Member'
									: group.pivot.role
							}}
						</td>
						<td>{{ group.name }}</td>
						<td>{{ group.owner_name }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
import axios from 'axios';

export default {
	props: {
		user: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			groups: [],
		};
	},
	watch: {
		'user.id': function (newVal, oldVal) {
			if (newVal !== oldVal) {
				this.getUserGroups();
			}
		},
	},
	methods: {
		getUserGroups() {
			axios
				.get(`/api/admin/users/${this.user.id}/groups`)
				.then((response) => {
					this.groups = response.data;
				})
				.catch((error) => {
					console.error('Error fetching user groups:', error);
				});
		},
	},
	mounted() {
		this.getUserGroups();
	},
};
</script>
